import React from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { SurgeriesProvider } from "./SurgeriesContext";
import { SurgeriesScreen } from "./screens/SurgeriesScreen";
import { SurgeriesDetailsScreen } from "./screens/SurgeriesDetailsScreen";
import { SurgeriesCompleteScreen } from "./screens/SurgeriesCompleteScreen";
import { MedicalHistoryQuestionProvider } from "@src/packages/medical-history/components";

export type SurgeriesStackParamList = {
  SurgeriesIntro: undefined;
  SurgeriesDetails: undefined;
  SurgeriesComplete: undefined;
};

const Stack = createNativeStackNavigator<SurgeriesStackParamList>();

export function SurgeriesNavigator() {
  return (
    <SurgeriesProvider>
      <MedicalHistoryQuestionProvider
        section="surgeries"
        sectionLabelKey="med_history.review.section_title.surgeries"
        helpTextKey="med_history.question_screen.flow_help.surgeries"
      >
        <Stack.Navigator
          initialRouteName="SurgeriesIntro"
          screenOptions={{
            headerShown: false,
            contentStyle: { backgroundColor: "transparent" },
          }}
        >
          <Stack.Screen name="SurgeriesIntro" component={SurgeriesScreen} />
          <Stack.Screen
            name="SurgeriesDetails"
            component={SurgeriesDetailsScreen}
          />
          <Stack.Screen
            name="SurgeriesComplete"
            component={SurgeriesCompleteScreen}
          />
        </Stack.Navigator>
      </MedicalHistoryQuestionProvider>
    </SurgeriesProvider>
  );
}
